import { Box, Card, Text, Badge, Flex, Image, Button } from '@mantine/core'
import React from 'react'
import classes from './ProgramCard.module.css'
import NoImage from '../../../assets/img/no-image.png'
import { getImageFile } from '../../../services/fileImage'
import { useNavigate } from 'react-router-dom'
import { formatPrice } from '../../../plugins/formatPrice'
import { useViewportSize } from '@mantine/hooks'

const TemplateCard = ({ data }) => {
  const { width } = useViewportSize()
  const navigate = useNavigate()

  const mappingPrice = (typeTraining) => {
    if (typeTraining === 'course') {
      return (
        <Text className={classes.priceProgram} c="red">{formatPrice(data.price)}</Text>
      )
    } else {
      return (
        <Text className={classes.priceProgram} c="red">{data.latestSchedule !== null ? formatPrice(data.latestSchedule.price): 'Belum Tersedia'}</Text>
      )
    }
  }

  return (
    <Card className={classes.programCard} shadow='sm' radius='md' padding={width > 768 ? 8 : 6} withBorder onClick={() => navigate(`/${data.kind}/${data.slug}`)}>
      <Card.Section pos='relative'>
        <Image src={data.eventImages.length === 0 ? NoImage : getImageFile(data.eventImages[0].filepath)} />
        <Box className={classes.typeProgram}>
          <Badge color='#ff860b' variant="filled" size={width > 768 ? 'xs' : 10} fz={width > 768 ? 8 : 6} >
            {data.eventCategory.name}
          </Badge>
        </Box>
      </Card.Section>
      <Box p={width > 768 ? 4 : 2}>
        <Box>
          <Text className={classes.titleProgram} lineClamp={2}>{data.name}</Text>
        </Box>
        <Box my={12}>
          <Flex justify={data.latestSchedule !== null ? 'space-between' : 'end'} align="center">
            <Text className={classes.discountText} c="red">{data.latestSchedule !== null && data.latestSchedule.price < data.price ? `${((data.price - data.latestSchedule.price) / data.price * 100).toFixed(0)}%` : ''}</Text>
            {mappingPrice(data.kind)}
          </Flex>
        </Box>
        <Box>
          <Button className={classes.buttonProgram} fullWidth color='indigo.9'>Beli Sekarang</Button>
        </Box>
      </Box>
    </Card>
  )
}

export default TemplateCard